module.exports = __webpack_public_path__ + "img/group.67420220.png";